import MissingInformationSteps from 'app/components/Core/LineItem/MissingInformation/Steps'
import KDrawer from 'app/components/Modules/Feedback/KDrawer'
import { RecordType } from 'app/constants/GlobalTypes'
import { PageProps } from 'app/pages/typing'
import { Routes } from 'app/routes/Routes'
import * as React from 'react'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

const MissingInformation: React.FC<PageProps> = () => {
  const navigate = useNavigate()
  const { rental_id } = useParams<{ rental_id: string }>()
  const goBack = () => navigate(Routes.Rental.member(rental_id).show)
  const [subtitle, setSubtitle] = useState<string>(null)

  return (
    <KDrawer
      width={600}
      open
      recordType={RecordType.line_item}
      subtitle={subtitle}
      action="update_information"
      onClose={goBack}>
      <MissingInformationSteps
        member={{ id: Number(rental_id) }}
        props={{ onSuccess: goBack, setSubtitle }}
      />
    </KDrawer>
  )
}

export default MissingInformation
